module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_categorization-6e32cad108954e80ccb227cd43d99325.svg";